// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../vninvestcharts-widget/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lLPRDaajUSdZN9IDSBIW {
  position: absolute;
  z-index: 100;
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 4px 8px;
  background: var(--vnsc-bg-secondary, #111820);
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 6px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
  font-size: 11px;
  color: var(--vnsc-text-primary, #e0e0e0);
  user-select: none;
  white-space: nowrap;
  cursor: grab;
}

.lLPRDaajUSdZN9IDSBIW:active {
  cursor: grabbing;
}

.GKAiQXVv5hFYQbcVP4y3 {
  width: 1px;
  height: 18px;
  background: var(--vnsc-border, #2a2a2a);
  margin: 0 4px;
  flex-shrink: 0;
}

.GHT_4I5jYtKdRfyDezr4 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 3px;
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  cursor: pointer;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.GHT_4I5jYtKdRfyDezr4:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--vnsc-text-primary, #e0e0e0);
}

.L1nUqiNR8PrLAhcKBWuQ {
  color: var(--vnsc-primary, #2962ff);
}

.FjIqxo5_tNYZhztXLBxq {
  width: 80px;
  height: 3px;
  accent-color: var(--vnsc-accent, #2962ff);
  cursor: pointer;
  flex-shrink: 0;
}

.KdL5byh4Iw93Ci7YdIse {
  font-size: 10px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  min-width: 40px;
  flex-shrink: 0;
}

.Q6g6j0s5944iJEZONFL1 {
  font-size: 11px;
  font-weight: 600;
}

.Q6g6j0s5944iJEZONFL1[data-pnl-positive="true"] {
  color: #22bb5c;
}

.Q6g6j0s5944iJEZONFL1[data-pnl-positive="false"] {
  color: #d7324b;
}

.OBXGRxlbywbDqu2tAW0S {
  background: transparent;
  border: 1px solid var(--vnsc-border, #2a2a2a);
  border-radius: 3px;
  color: var(--vnsc-text-secondary, #a0a0a0);
  font-size: 10px;
  padding: 1px 3px;
  cursor: pointer;
  flex-shrink: 0;
}

.ezUsjUdSw8uaKAQUIF7H {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 3px;
  background: transparent;
  color: var(--vnsc-text-secondary, #a0a0a0);
  cursor: pointer;
  font-size: 13px;
  line-height: 1;
  transition: all 0.15s ease;
  flex-shrink: 0;
}

.ezUsjUdSw8uaKAQUIF7H:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--vnsc-text-primary, #e0e0e0);
}
`, "",{"version":3,"sources":["webpack://./src/widget/components/replay/FloatingReplayToolbar.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,6CAA6C;EAC7C,6CAA6C;EAC7C,kBAAkB;EAClB,yCAAyC;EACzC,yDAAyD;EACzD,eAAe;EACf,wCAAwC;EACxC,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,uCAAuC;EACvC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,0CAA0C;EAC1C,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6CAA6C;EAC7C,kBAAkB;EAClB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,wCAAwC;AAC1C","sourcesContent":[".toolbar {\r\n  position: absolute;\r\n  z-index: 100;\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 2px;\r\n  padding: 4px 8px;\r\n  background: var(--vnsc-bg-secondary, #111820);\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 6px;\r\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);\r\n  font-family: Helvetica Neue, Helvetica, Arial, sans-serif;\r\n  font-size: 11px;\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n  user-select: none;\r\n  white-space: nowrap;\r\n  cursor: grab;\r\n}\r\n\r\n.toolbar:active {\r\n  cursor: grabbing;\r\n}\r\n\r\n.separator {\r\n  width: 1px;\r\n  height: 18px;\r\n  background: var(--vnsc-border, #2a2a2a);\r\n  margin: 0 4px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.transportBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border: none;\r\n  border-radius: 3px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  cursor: pointer;\r\n  transition: all 0.15s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.transportBtn:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n\r\n.transportBtnActive {\r\n  color: var(--vnsc-primary, #2962ff);\r\n}\r\n\r\n.slider {\r\n  width: 80px;\r\n  height: 3px;\r\n  accent-color: var(--vnsc-accent, #2962ff);\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.progress {\r\n  font-size: 10px;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  min-width: 40px;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.pnl {\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n}\r\n\r\n.pnl[data-pnl-positive=\"true\"] {\r\n  color: #22bb5c;\r\n}\r\n\r\n.pnl[data-pnl-positive=\"false\"] {\r\n  color: #d7324b;\r\n}\r\n\r\n.speedSelect {\r\n  background: transparent;\r\n  border: 1px solid var(--vnsc-border, #2a2a2a);\r\n  border-radius: 3px;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  font-size: 10px;\r\n  padding: 1px 3px;\r\n  cursor: pointer;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.closeBtn {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border: none;\r\n  border-radius: 3px;\r\n  background: transparent;\r\n  color: var(--vnsc-text-secondary, #a0a0a0);\r\n  cursor: pointer;\r\n  font-size: 13px;\r\n  line-height: 1;\r\n  transition: all 0.15s ease;\r\n  flex-shrink: 0;\r\n}\r\n\r\n.closeBtn:hover {\r\n  background: rgba(255, 255, 255, 0.1);\r\n  color: var(--vnsc-text-primary, #e0e0e0);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `lLPRDaajUSdZN9IDSBIW`,
	"separator": `GKAiQXVv5hFYQbcVP4y3`,
	"transportBtn": `GHT_4I5jYtKdRfyDezr4`,
	"transportBtnActive": `L1nUqiNR8PrLAhcKBWuQ`,
	"slider": `FjIqxo5_tNYZhztXLBxq`,
	"progress": `KdL5byh4Iw93Ci7YdIse`,
	"pnl": `Q6g6j0s5944iJEZONFL1`,
	"speedSelect": `OBXGRxlbywbDqu2tAW0S`,
	"closeBtn": `ezUsjUdSw8uaKAQUIF7H`
};
export default ___CSS_LOADER_EXPORT___;
